import { RestProvider } from 'dataSources/types/restProvider';
import { BaseResource } from 'e100-data-providers';

import { CarEBoxLocations, EBoxDashboardData, GetObuDevicesByClientCodeResponseDto } from '../types';

export class CarsApi extends BaseResource {
  path: string = '';

  constructor(provider: RestProvider) {
    super(provider);
    this.path = '';
  }

  getCarEBoxLocations(): Promise<CarEBoxLocations> {
    return this.getChildResource('navigation/autosCoordinates').getItems();
  }

  getCarEBoxDashboardData(obuSerialnumber: string): Promise<EBoxDashboardData> {
    return this.getChildResource(`Obu/getObuDashboardData?obuSerialNumber=${obuSerialnumber}`).getItems();
  }

  getT4EObuDevicesByClientCode(clientCode: string): Promise<GetObuDevicesByClientCodeResponseDto[]> {
    return this.getChildResource(`Obu/getT4EObuDevicesByClientCode?clientCode=${clientCode}`).getItems();
  }
}
